import BaseItemSerializer from './base-item';

export default class WfaSerializer extends BaseItemSerializer {}
